/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { List } from "@refinedev/antd";
import { IResourceComponentsProps, useNotification } from "@refinedev/core";
import { Button, Form, Input, Radio, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useConfigFee, useGetConfigFee } from "../../api/confitFee";
import { clearFieldErrorMessageOnChange } from "../../utils/form.constants";
import "../styles/index.css";

export const ServiceFee = {
  FIXED_FEE: "FIXED",
  PERCENTAGE: "PERCENTAGE",
};

export const CryptoTransferFee = {
  DYNAMIC: "DYNAMIC",
  FIXED_FEE: "FIXED",
  PERCENTAGE: "PERCENTAGE",
};

export const FiatTransferFee = {
  FIXED_FEE: "FIXED",
  PERCENTAGE: "PERCENTAGE",
};

export const ExchangeFee = {
  FIXED_FEE: "FIXED",
  PERCENTAGE: "PERCENTAGE",
};

export const ConfigFees: React.FC<IResourceComponentsProps> = () => {
  const [form] = Form.useForm();
  const { open: openNotification } = useNotification();
  const [serviceFee, setServiceFee] = useState(ServiceFee.FIXED_FEE);
  const [exchangeFee, setExchangeFee] = useState(ExchangeFee.FIXED_FEE);
  const [cryptoTransferFee, setCryptoTransferFee] = useState(
    CryptoTransferFee.DYNAMIC
  );

  const [fiatTransferFee, setFiatTransferFee] = useState(
    FiatTransferFee.FIXED_FEE
  );

  const { data, refetch } = useGetConfigFee();

  const { mutate: configFees } = useConfigFee({
    onSuccess: () => {
      if (openNotification) {
        openNotification({
          key: "success_transaction_confirm",
          message: "Update config fee successfully!",
          type: "success",
        });
      }
      refetch();
    },
    onError: (error: { message: string }) => {
      if (openNotification) {
        openNotification({
          key: "config_fee_error",
          message: error?.message || "Update config fee failed!",
          type: "error",
        });
      }
    },
  });

  const onSubmit = (values: any) => {
    const bodyServiceFee =
      serviceFee === ServiceFee.FIXED_FEE
        ? {
          serviceFeeFixedCrypto: Number(values?.serviceFeeFixedCrypto),
          serviceFeeFixedFiat: Number(values?.serviceFeeFixedFiat),
        }
        : {
          serviceFeePercentCrypto: Number(values?.serviceFeePercentCrypto),
          serviceFeePercentFiat: Number(values?.serviceFeePercentFiat),
        };

    const bodyCryptoTransferFee =
      cryptoTransferFee === CryptoTransferFee.DYNAMIC
        ? {}
        : cryptoTransferFee === CryptoTransferFee.FIXED_FEE
          ? { cryptoTransferFeeFixed: Number(values?.cryptoTransferFeeFixed) }
          : {
            cryptoTransferFeePercent: Number(values?.cryptoTransferFeePercent),
          };

    const bodyFiatTransferFee =
      fiatTransferFee === FiatTransferFee.FIXED_FEE
        ? { fiatTransferFeeFixed: Number(values?.fiatTransferFeeFixed) }
        : { fiatTransferFeePercent: Number(values?.fiatTransferFeePercent) };

    const bodyExchangeFee =
      exchangeFee === ExchangeFee.FIXED_FEE
        ? { exchangeMoneyFeeFixedCrypto: Number(values?.exchangeMoneyFeeFixedCrypto), exchangeMoneyFeeFixedFiat: Number(values?.exchangeMoneyFeeFixedFiat) }
        : { exchangeMoneyFeePercentCrypto: Number(values?.exchangeMoneyFeePercentCrypto), exchangeMoneyFeePercentFiat: Number(values?.exchangeMoneyFeePercentFiat) };

    const body = {
      serviceFeeType: serviceFee,
      ...bodyServiceFee,
      cryptoTransferFeeType: cryptoTransferFee,
      ...bodyCryptoTransferFee,
      fiatTransferFeeType: fiatTransferFee,
      ...bodyFiatTransferFee,
      exchangeMoneyFeeType: exchangeFee,
      ...bodyExchangeFee,
    };

    configFees(body);
  };

  useEffect(() => {
    if (!data) return;
    const reponse = data?.data?.data;
    form.setFieldsValue({
      serviceFeeFixedCrypto:
        reponse?.serviceFeeFixedCrypto === 0
          ? reponse?.serviceFeeFixedCrypto
          : reponse?.serviceFeeFixedCrypto || undefined,
      serviceFeeFixedFiat:
        reponse?.serviceFeeFixedFiat === 0
          ? reponse?.serviceFeeFixedFiat
          : reponse?.serviceFeeFixedFiat || undefined,
      serviceFeePercentCrypto:
        reponse?.serviceFeePercentCrypto === 0
          ? reponse?.serviceFeePercentCrypto
          : reponse?.serviceFeePercentCrypto || undefined,
      serviceFeePercentFiat:
        reponse?.serviceFeePercentFiat === 0
          ? reponse?.serviceFeePercentFiat
          : reponse?.serviceFeePercentFiat || undefined,
      cryptoTransferFeeFixed:
        reponse?.cryptoTransferFeeFixed === 0
          ? reponse?.cryptoTransferFeeFixed
          : reponse?.cryptoTransferFeeFixed || undefined,
      cryptoTransferFeePercent:
        reponse?.cryptoTransferFeePercent === 0
          ? reponse?.cryptoTransferFeePercent
          : reponse?.cryptoTransferFeePercent || undefined,
      fiatTransferFeeFixed:
        reponse?.fiatTransferFeeFixed === 0
          ? reponse?.fiatTransferFeeFixed
          : reponse?.fiatTransferFeeFixed || undefined,
      fiatTransferFeePercent:
        reponse?.fiatTransferFeePercent === 0
          ? reponse?.fiatTransferFeePercent
          : reponse?.fiatTransferFeePercent || undefined,

      exchangeMoneyFeeFixedCrypto:
        reponse?.exchangeMoneyFeeFixedCrypto === 0
          ? reponse?.exchangeMoneyFeeFixedCrypto
          : reponse?.exchangeMoneyFeeFixedCrypto || undefined,
      exchangeMoneyFeeFixedFiat:
        reponse?.exchangeMoneyFeeFixedFiat === 0
          ? reponse?.exchangeMoneyFeeFixedFiat
          : reponse?.exchangeMoneyFeeFixedFiat || undefined,
      exchangeMoneyFeePercentCrypto:
        reponse?.exchangeMoneyFeePercentCrypto === 0
          ? reponse?.exchangeMoneyFeePercentCrypto
          : reponse?.exchangeMoneyFeePercentCrypto || undefined,
      exchangeMoneyFeePercentFiat:
        reponse?.exchangeMoneyFeePercentFiat === 0
          ? reponse?.exchangeMoneyFeePercentFiat
          : reponse?.exchangeMoneyFeePercentFiat || undefined,
    });
    setServiceFee(reponse?.serviceFeeType);
    setCryptoTransferFee(reponse?.cryptoTransferFeeType);
    setFiatTransferFee(reponse?.fiatTransferFeeType);
    setExchangeFee(reponse?.exchangeMoneyFeeType);
  }, [data, form]);

  return (
    <>
      <List title="Fees Configuration">
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          disabled={false}
          onChange={() => clearFieldErrorMessageOnChange(form)}
        >
          <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Typography style={{ marginTop: "13px", width: "140px" }}>
              Service Fee:
            </Typography>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "170px", marginTop: "13px" }}>
                  <Radio
                    value={ServiceFee.FIXED_FEE}
                    checked={serviceFee === ServiceFee.FIXED_FEE}
                    onClick={() => setServiceFee(ServiceFee.FIXED_FEE)}
                  >
                    Fixed Fee (USD)
                  </Radio>
                </div>
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <Form.Item
                    name="serviceFeeFixedCrypto"
                    rules={[
                      {
                        required:
                          serviceFee === ServiceFee.FIXED_FEE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={serviceFee !== ServiceFee.FIXED_FEE}
                      placeholder="Input for Crypto"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item
                    name="serviceFeeFixedFiat"
                    rules={[
                      {
                        required:
                          serviceFee === ServiceFee.FIXED_FEE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={serviceFee !== ServiceFee.FIXED_FEE}
                      placeholder="Input for Fiat"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "170px", marginTop: "13px" }}>
                  <Radio
                    value={ServiceFee.PERCENTAGE}
                    checked={serviceFee === ServiceFee.PERCENTAGE}
                    onClick={() => setServiceFee(ServiceFee.PERCENTAGE)}
                  >
                    Percentage
                  </Radio>
                </div>
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <Form.Item
                    name="serviceFeePercentCrypto"
                    rules={[
                      {
                        required:
                          serviceFee === ServiceFee.PERCENTAGE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={serviceFee !== ServiceFee.PERCENTAGE}
                      placeholder="Input for Crypto"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item
                    name="serviceFeePercentFiat"
                    rules={[
                      {
                        required:
                          serviceFee === ServiceFee.PERCENTAGE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={serviceFee !== ServiceFee.PERCENTAGE}
                      placeholder="Input for Fiat"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row", gap: 10, borderTop: "1px solid #000000", paddingTop: "13px" }}>
            <Typography style={{ marginTop: "13px", width: "140px" }}>
              Exchange Fee:
            </Typography>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "170px", marginTop: "13px" }}>
                  <Radio
                    value={ExchangeFee.FIXED_FEE}
                    checked={exchangeFee === ExchangeFee.FIXED_FEE}
                    onClick={() => setExchangeFee(ExchangeFee.FIXED_FEE)}
                  >
                    Fixed Fee (USD)
                  </Radio>
                </div>
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <Form.Item
                    name="exchangeMoneyFeeFixedCrypto"
                    rules={[
                      {
                        required:
                          exchangeFee === ExchangeFee.FIXED_FEE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={exchangeFee !== ExchangeFee.FIXED_FEE}
                      placeholder="Input for Crypto"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item
                    name="exchangeMoneyFeeFixedFiat"
                    rules={[
                      {
                        required:
                          exchangeFee === ExchangeFee.FIXED_FEE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={exchangeFee !== ExchangeFee.FIXED_FEE}
                      placeholder="Input for Fiat"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "170px", marginTop: "13px" }}>
                  <Radio
                    value={ExchangeFee.PERCENTAGE}
                    checked={exchangeFee === ExchangeFee.PERCENTAGE}
                    onClick={() => setExchangeFee(ExchangeFee.PERCENTAGE)}
                  >
                    Percentage
                  </Radio>
                </div>
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <Form.Item
                    name="exchangeMoneyFeePercentCrypto"
                    rules={[
                      {
                        required:
                          exchangeFee === ExchangeFee.PERCENTAGE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={exchangeFee === ExchangeFee.FIXED_FEE}
                      placeholder="Input for Crypto"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item
                    name="exchangeMoneyFeePercentFiat"
                    rules={[
                      {
                        required:
                          exchangeFee === ExchangeFee.PERCENTAGE ? true : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={exchangeFee === ExchangeFee.FIXED_FEE}
                      placeholder="Input for Fiat"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
          <div style={{ borderTop: "1px solid #000000" }}>
            <Typography style={{ marginTop: "13px" }}>Transfer Fee</Typography>
            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
              <Typography style={{ marginTop: "13px", width: "140px" }}>
                Crypto Transfer Fee:
              </Typography>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div
                    style={{
                      width: "170px",
                      marginTop: "13px",
                      marginBottom: "25px",
                    }}
                  >
                    <Radio
                      value={CryptoTransferFee.DYNAMIC}
                      checked={cryptoTransferFee === CryptoTransferFee.DYNAMIC}
                      onClick={() =>
                        setCryptoTransferFee(CryptoTransferFee.DYNAMIC)
                      }
                    >
                      Dynamic - Medium
                    </Radio>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "170px", marginTop: "13px" }}>
                    <Radio
                      value={CryptoTransferFee.FIXED_FEE}
                      checked={
                        cryptoTransferFee === CryptoTransferFee.FIXED_FEE
                      }
                      onClick={() =>
                        setCryptoTransferFee(CryptoTransferFee.FIXED_FEE)
                      }
                    >
                      Fixed Fee (USD)
                    </Radio>
                  </div>
                  <Form.Item
                    name="cryptoTransferFeeFixed"
                    rules={[
                      {
                        required:
                          cryptoTransferFee === CryptoTransferFee.FIXED_FEE
                            ? true
                            : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        cryptoTransferFee !== CryptoTransferFee.FIXED_FEE
                      }
                      placeholder="Input"
                      size="large"
                    />
                  </Form.Item>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "170px", marginTop: "13px" }}>
                    <Radio
                      value={CryptoTransferFee.PERCENTAGE}
                      checked={
                        cryptoTransferFee === CryptoTransferFee.PERCENTAGE
                      }
                      onClick={() =>
                        setCryptoTransferFee(CryptoTransferFee.PERCENTAGE)
                      }
                    >
                      Percentage
                    </Radio>
                  </div>
                  <Form.Item
                    name="cryptoTransferFeePercent"
                    rules={[
                      {
                        required:
                          cryptoTransferFee === CryptoTransferFee.PERCENTAGE
                            ? true
                            : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        cryptoTransferFee !== CryptoTransferFee.PERCENTAGE
                      }
                      placeholder="Input"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
              <Typography style={{ marginTop: "13px", width: "140px" }}>
                Fiat Transfer Fee:
              </Typography>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "170px", marginTop: "13px" }}>
                    <Radio
                      value={FiatTransferFee.FIXED_FEE}
                      checked={fiatTransferFee === FiatTransferFee.FIXED_FEE}
                      onClick={() =>
                        setFiatTransferFee(FiatTransferFee.FIXED_FEE)
                      }
                    >
                      Fixed Fee (USD)
                    </Radio>
                  </div>
                  <Form.Item
                    name="fiatTransferFeeFixed"
                    rules={[
                      {
                        required:
                          fiatTransferFee === FiatTransferFee.FIXED_FEE
                            ? true
                            : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={fiatTransferFee !== FiatTransferFee.FIXED_FEE}
                      placeholder="Input"
                      size="large"
                    />
                  </Form.Item>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "170px", marginTop: "13px" }}>
                    <Radio
                      value={FiatTransferFee.PERCENTAGE}
                      checked={fiatTransferFee === FiatTransferFee.PERCENTAGE}
                      onClick={() =>
                        setFiatTransferFee(FiatTransferFee.PERCENTAGE)
                      }
                    >
                      Percentage
                    </Radio>
                  </div>
                  <Form.Item
                    name="fiatTransferFeePercent"
                    rules={[
                      {
                        required:
                          fiatTransferFee === FiatTransferFee.PERCENTAGE
                            ? true
                            : false,
                        message: `This field is required`,
                      },
                    ]}
                  >
                    <Input
                      disabled={fiatTransferFee !== FiatTransferFee.PERCENTAGE}
                      placeholder="Input"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
          <Button
            key="save"
            type="primary"
            onClick={() => form?.submit()}
            loading={false}
            className="smartFooterButtonXS"
          >
            Save
          </Button>
        </Form>
      </List>
    </>
  );
};
